import { Item, NoneDecoratedLink, StyledButton } from './ProductItemDesktop';
import LogoCMP from '../../assets/svg/modul_icon_CMP.svg';
import { useContext, FunctionComponent } from 'react';
import AppContext from 'src/AppContext';
import { Box, Flex, IconExport } from '@gmg/gmg-react-components';
import { isOrganizationLevelAdminRole } from 'src/role';
import { organizationPaths, ROUTES } from 'src/routes';
import { getGoToHelpDeskEvent, getOpenOrDownloadAppEvent } from 'src/tracking';
import { useTranslation } from 'react-i18next';

const CMPModule: FunctionComponent = () => {
    const { trackEvent, language, user: contextUser } = useContext(AppContext);
    const { t } = useTranslation();
    const user = contextUser!;
    const lngCode = language === 'de' ? 'de-de' : 'en-us';
    const cmpPath = isOrganizationLevelAdminRole(user.role) ? organizationPaths.root(user.orgId!) : ROUTES.organizations;
    const cmpModuleName = 'GMG Manage';
    return (
        <Item key={cmpModuleName} showTwoButtons={false}>
            <LogoCMP width={48} height={48} aria-label={`${cmpModuleName} Logo`} />
            <span className='px12_600_contrast' aria-label={cmpModuleName}>{cmpModuleName}</span>
            <Box width='100%'>
                <NoneDecoratedLink to={cmpPath} aria-label={`Open ${cmpModuleName}`}>
                    <StyledButton
                        size="normal"
                        variant="secondary"
                        aria-label="Open Cmp"
                        onClick={() => { trackEvent(getOpenOrDownloadAppEvent('CMP')); }}
                    >
                        {t('UserProfile.open_button', 'Open')}
                    </StyledButton>
                </NoneDecoratedLink>
            </Box>
            <Flex width='100%' justifyContent='center' className='px12_600_contrast'>
                {'—'}
            </Flex>
            <Flex justifyContent='center' alignItems='center' width='100%'>
                <NoneDecoratedLink
                    to={`https://customercare.gmgcolor.com/hc/${lngCode}/sections/26519126197915`}
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label={`Help center for ${cmpModuleName}`}
                    onClick={() => { trackEvent(getGoToHelpDeskEvent(cmpModuleName)); }}
                >
                    <IconExport height={16} width={16} />
                </NoneDecoratedLink>
            </Flex>
        </Item>
    );
};
export default CMPModule;
